import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import { CheckIcon } from 'lucide-react';
import * as React from 'react';

import { Label } from './label';
import { Typography, TypographyVariant } from './typography';

function Checkbox({
  className,
  label,
  labelVariant = 'body1',
  labelClassName,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  label?: React.ReactNode;
  labelVariant?: TypographyVariant;
  labelClassName?: string;
}) {
  const id = React.useId();

  return (
    <div className={clsx(label && 'flex items-center gap-2', className)}>
      <CheckboxPrimitive.Root
        id={label ? id : undefined}
        data-slot="checkbox"
        className={clsx(
          'border-fx-neutral-400 data-[state=checked]:bg-fx-primary dark:data-[state=checked]:bg-fx-primary data-[state=checked]:border-fx-primary h-4 w-4 shrink-0 rounded border bg-white outline-none transition-shadow focus-visible:ring data-[state=checked]:text-white',
          'disabled:bg-fx-neutral-50 disabled:border-fx-neutral-200 disabled:cursor-not-allowed',
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center text-current transition-none"
        >
          <CheckIcon className="size-3.5 text-current" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {label && (
        <Label htmlFor={id}>
          {typeof label === 'string' ? (
            <Typography variant={labelVariant} className={labelClassName}>
              {label}
            </Typography>
          ) : (
            label
          )}
        </Label>
      )}
    </div>
  );
}

export { Checkbox };
